import { render } from "./lotteryBetDetail.vue?vue&type=template&id=0ef36220&scoped=true"
import script from "./lotteryBetDetail.vue?vue&type=script&lang=js"
export * from "./lotteryBetDetail.vue?vue&type=script&lang=js"

import "./lotteryBetDetail.vue?vue&type=style&index=0&id=0ef36220&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ef36220"]])

export default __exports__